import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Privacy from './Privacy';
import Terms from './Terms';
import ContactSupport from './ContactSupport';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contactSupport" element={<ContactSupport />} />
      </Routes>
    </Router>
  );
}

export default App;
